import type { FormController } from "@mittwald/flow-components/dist/components/Form";
import { WizardStep } from "@mittwald/flow-components/dist/components/Wizard/components/WizardStep";
import React from "react";
import { LoginStepContent } from "./LoginStepContent";

interface LoginForm {
  identifier: string;
  password: string;
}

interface LoginStepProps {
  form: FormController<LoginForm>;
  isNewSystem: boolean;
  formError: string | null;
}

export const LoginStep: React.FC<LoginStepProps> = (props) => {
  const { form, isNewSystem, formError } = props;
  return (
    <WizardStep form={form} id="login" indicatorText="login">
      <LoginStepContent formError={formError} isNewSystem={isNewSystem} />
    </WizardStep>
  );
};
